import {
  TemplateVariableDefinitionDto,
  TemplateVariableType,
} from '@/features/dashboard/messageTemplates/types/TemplateVariableDefinitionDto.ts';

export const isBlockVariable = (
  variable: TemplateVariableDefinitionDto,
): boolean => variable.type === TemplateVariableType.HTML;
